import { render, staticRenderFns } from "./AppOrder.vue?vue&type=template&id=4e831030&scoped=true&"
import script from "./AppOrder.vue?vue&type=script&lang=js&"
export * from "./AppOrder.vue?vue&type=script&lang=js&"
import style0 from "./AppOrder.vue?vue&type=style&index=0&id=4e831030&prod&lang=scss&scoped=true&"
import style1 from "./AppOrder.vue?vue&type=style&index=1&id=4e831030&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e831030",
  null
  
)

export default component.exports